import userSettings from "@/components/mixins/user-settings"

export default {
	mixins: [userSettings],
	data() {
		return {
			moduleName: '',
			detailPageRouteName: '',
		}
	},
	props: {
		entity: Object,
		selectedEntities: Array
	},
	computed: {
		$_deleteActionAllowed() {
			return this.$_loggedUser_operator_item_delete_action_allowed(this.entity.id_operator);
		},
		$_updateActionAllowed() {
			return this.$_loggedUser_operator_item_update_action_allowed(this.entity.id_operator);
		},
		isChecked() {
			return this.selectedEntities.indexOf(String(this.entity.id)) > -1
		}
	},
	methods: {
		onChange: function (e) {
			this.$emit('input', e)
		},
		goToDetail(e, id) {
			this.$router.push({name: this.detailPageRouteName, params: {id: id}})
		},
		emitUpdateEntity(params) { // beware if ID is integer or string
			this.$emit('updateEntity', {'id': String(this.entity.id), 'params': params})
		},
		emitDeleteEntity() {
			this.$emit('deleteEntity', this.entity.id)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/row-actions.js